// import React, { useContext, useEffect, useState } from 'react';
// import { themeContext } from '../Context';

// const FocusModeButton = ({ onClick, darkMode, size }) => {
//     const isMobile = window.innerWidth <= 768;

//     return (
//         <button
//             onClick={onClick}
//             className="action-button"
//             style={{
//                 padding: isMobile ? '8px 12px' : '10px 16px',
//                 borderRadius: '8px',
//                 border: 'none',
//                 backgroundColor: '#9c27b0',
//                 color: 'white',
//                 fontSize: isMobile ? '12px' : '14px',
//                 cursor: 'pointer',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '6px',
//                 transition: 'all 0.2s ease',
//                 boxShadow: '0 4px 12px rgba(156, 39, 176, 0.3)',
//             }}
//             onMouseEnter={(e) => {
//                 e.target.style.backgroundColor = '#7b1fa2';
//                 e.target.style.transform = 'scale(1.02)';
//             }}
//             onMouseLeave={(e) => {
//                 e.target.style.backgroundColor = '#9c27b0';
//                 e.target.style.transform = 'scale(1)';
//             }}
//         >
//             <span style={{ fontSize: '16px' }}>🔍</span>
//             Focus Mode
//         </button>
//     );
// };

// const FocusModePopup = ({
//     isOpen,
//     onClose,
//     question,
//     language,
//     questionNumber,
//     onOptionSelect, // New prop to handle option selection
//     selectedOption, // New prop to track selected option
//     showCorrectAnswer = false // New prop to show correct answer after selection
// }) => {
//     const theme = useContext(themeContext);
//     const darkMode = theme.state.darkMode;
//     const [localSelectedOption, setLocalSelectedOption] = useState(null);

//     // Reset selected option when question changes
//     useEffect(() => {
//         setLocalSelectedOption(null);
//     }, [question]);

//     // Handle escape key
//     useEffect(() => {
//         const handleEscKey = (event) => {
//             if (event.key === 'Escape' && isOpen) {
//                 onClose();
//             }
//         };

//         if (isOpen) {
//             document.body.style.overflow = "hidden";
//             window.addEventListener('keydown', handleEscKey);
//         }

//         return () => {
//             document.body.style.overflow = "auto";
//             window.removeEventListener('keydown', handleEscKey);
//         };
//     }, [isOpen, onClose]);

//     if (!isOpen || !question) return null;

//     // Get localized question directly in the popup
//     const getLocalizedQuestion = () => {
//         if (!question) return { question: '', options: [] };

//         if (language === 'en') {
//             return {
//                 question: question.question,
//                 options: question.options
//             };
//         }

//         if (language === 'hi' && question.questionHi) {
//             return {
//                 question: question.questionHi,
//                 options: question.optionsHi || question.options
//             };
//         }

//         if (language === 'bilingual' && question.questionHi) {
//             return {
//                 question: `${question.question}\n\n${question.questionHi}`,
//                 options: question.options.map((enOpt, idx) => {
//                     const hiOpt = question.optionsHi?.[idx];
//                     return hiOpt ? `${enOpt} / ${hiOpt}` : enOpt;
//                 })
//             };
//         }

//         return {
//             question: question.question,
//             options: question.options
//         };
//     };

//     // Get option style based on selection and correctness
//     const getOptionStyle = (option, index) => {
//         const isSelected = localSelectedOption === index;
//         const isCorrect = question.options[index] === question.correctAnswer;

//         // Base style
//         const baseStyle = {
//             padding: '16px 20px',
//             borderRadius: '12px',
//             border: '1px solid',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '12px',
//             cursor: 'pointer',
//             transition: 'all 0.2s ease',
//             marginBottom: "10px"
//         };

//         // If no option selected yet
//         if (localSelectedOption === null) {
//             return {
//                 ...baseStyle,
//                 backgroundColor: darkMode ? '#1e293b' : '#ffffff',
//                 borderColor: darkMode ? '#334155' : '#e2e8f0',
//                 color: darkMode ? '#f1f5f9' : '#0f172a',
//                 ':hover': {
//                     transform: 'translateY(-2px)',
//                     boxShadow: darkMode ? '0 4px 12px rgba(192, 132, 252, 0.2)' : '0 4px 12px rgba(124, 58, 237, 0.2)',
//                 }
//             };
//         }

//         // After selection - show correct/incorrect
//         if (isSelected) {
//             if (isCorrect) {
//                 return {
//                     ...baseStyle,
//                     backgroundColor: darkMode ? '#1e4a2a' : '#d4edda',
//                     borderColor: darkMode ? '#2d6a4f' : '#28a745',
//                     color: darkMode ? '#ffffff' : '#155724',
//                     fontWeight: '600',
//                 };
//             } else {
//                 return {
//                     ...baseStyle,
//                     backgroundColor: darkMode ? '#5a2a2a' : '#f8d7da',
//                     borderColor: darkMode ? '#b02a37' : '#dc3545',
//                     color: darkMode ? '#ffffff' : '#721c24',
//                     fontWeight: '600',
//                 };
//             }
//         }

//         // Show correct answer if user has selected something
//         if (showCorrectAnswer && isCorrect) {
//             return {
//                 ...baseStyle,
//                 backgroundColor: darkMode ? '#1e4a2a' : '#d4edda',
//                 borderColor: darkMode ? '#2d6a4f' : '#28a745',
//                 color: darkMode ? '#ffffff' : '#155724',
//                 opacity: '0.9',
//             };
//         }

//         // Dimmed style for other options after selection
//         return {
//             ...baseStyle,
//             backgroundColor: darkMode ? '#1e293b' : '#f8fafc',
//             borderColor: darkMode ? '#334155' : '#e2e8f0',
//             color: darkMode ? '#94a3b8' : '#64748b',
//             opacity: '0.7',
//         };
//     };

//     const handleOptionClick = (index) => {
//         if (localSelectedOption === null) {
//             setLocalSelectedOption(index);
//             if (onOptionSelect) {
//                 onOptionSelect(question.id, index);
//             }
//         }
//     };

//     const localizedQuestion = getLocalizedQuestion();

//     const formatExplanation = (text, language, hindiText) => {
//         if (!text) return null;

//         if (language === 'bilingual' && hindiText) {
//             const lines = text.split('\n');
//             const hindiLines = hindiText.split('\n');
//             const mergedLines = [];

//             const maxLines = Math.max(lines.length, hindiLines.length);

//             for (let i = 0; i < maxLines; i++) {
//                 const engLine = lines[i] || '';
//                 const hinLine = hindiLines[i] || '';

//                 if (engLine.trim() === '' && hinLine.trim() === '') {
//                     mergedLines.push('');
//                     continue;
//                 }

//                 mergedLines.push(`${engLine} / ${hinLine}`);
//             }
//             return mergedLines.join('\n');
//         }

//         if (language === 'hi' && hindiText) {
//             return hindiText;
//         }

//         return text;
//     };

//     const getExplanationTitle = () => {
//         switch (language) {
//             case 'hi': return 'व्याख्या';
//             case 'bilingual': return 'Explanation / व्याख्या';
//             default: return 'Explanation';
//         }
//     };

//     return (
//         <div style={styles.container}>
//             {/* Background Overlay */}
//             <div
//                 style={{
//                     ...styles.overlay,
//                     backgroundColor: darkMode ? 'rgba(0, 0, 0, 0.9)' : 'rgba(0, 0, 0, 0.7)',
//                 }}
//                 onClick={onClose}
//             />

//             {/* Focused Content */}
//             <div style={{
//                 ...styles.contentWrapper,
//                 backgroundColor: darkMode ? '#0f172a' : '#ffffff',
//                 maxWidth: window.innerWidth <= 768 ? '95%' : '800px',
//             }}>
//                 {/* Header */}
//                 <div style={{
//                     ...styles.header,
//                     backgroundColor: darkMode ? '#2e1a47' : '#f5f0ff',
//                     borderBottomColor: darkMode ? '#c084fc' : '#7c3aed',
//                 }}>
//                     <span style={styles.headerIcon}>📌</span>
//                     <span style={{
//                         ...styles.headerTitle,
//                         color: darkMode ? '#f1f5f9' : '#0f172a',
//                     }}>
//                         Question {questionNumber}
//                     </span>
//                     <button
//                         onClick={onClose}
//                         style={{
//                             ...styles.closeButton,
//                             backgroundColor: darkMode ? '#1e293b' : '#ffffff',
//                             color: darkMode ? '#c084fc' : '#7c3aed',
//                         }}
//                         onMouseEnter={(e) => {
//                             e.target.style.backgroundColor = darkMode ? '#334155' : '#f5f0ff';
//                             e.target.style.transform = 'scale(1.05)';
//                         }}
//                         onMouseLeave={(e) => {
//                             e.target.style.backgroundColor = darkMode ? '#1e293b' : '#ffffff';
//                             e.target.style.transform = 'scale(1)';
//                         }}
//                     >
//                         ✕
//                     </button>
//                 </div>

//                 {/* Content */}
//                 <div style={styles.content}>
//                     {/* Question Text */}
//                     <div style={{
//                         ...styles.questionContainer,
//                         backgroundColor: darkMode ? '#1e293b' : '#f8fafc',
//                         borderColor: darkMode ? '#334155' : '#e2e8f0',
//                     }}>
//                         <h3 style={{
//                             fontSize: window.innerWidth <= 768 ? '18px' : '20px',
//                             fontWeight: '600',
//                             color: darkMode ? '#f1f5f9' : '#0f172a',
//                             margin: 0,
//                             lineHeight: '1.6',
//                             whiteSpace: 'pre-line'
//                         }}>
//                             {localizedQuestion.question}
//                         </h3>
//                         {question.exam && (
//                             <p style={{
//                                 fontSize: '13px',
//                                 color: darkMode ? '#94a3b8' : '#64748b',
//                                 marginTop: '12px',
//                                 fontStyle: 'italic'
//                             }}>
//                                 {question.exam}
//                             </p>
//                         )}
//                     </div>

//                     {/* Options - Now Clickable */}
//                     <div style={{
//                         // display: 'grid',
//                         // gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : '1fr 1fr',
//                         // gap: '12px',
//                     }}>
//                         {localizedQuestion.options.map((option, idx) => (
//                             <div
//                                 key={idx}
//                                 onClick={() => handleOptionClick(idx)}
//                                 style={getOptionStyle(option, idx)}
//                                 onMouseEnter={(e) => {
//                                     if (localSelectedOption === null) {
//                                         e.currentTarget.style.transform = 'translateY(-2px)';
//                                         e.currentTarget.style.boxShadow = darkMode
//                                             ? '0 4px 12px rgba(192, 132, 252, 0.2)'
//                                             : '0 4px 12px rgba(124, 58, 237, 0.2)';
//                                     }
//                                 }}
//                                 onMouseLeave={(e) => {
//                                     if (localSelectedOption === null) {
//                                         e.currentTarget.style.transform = 'translateY(0)';
//                                         e.currentTarget.style.boxShadow = 'none';
//                                     }
//                                 }}
//                             >
//                                 <span style={{
//                                     width: '32px',
//                                     height: '32px',
//                                     borderRadius: '8px',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     color: 'white',
//                                     fontWeight: 'bold',
//                                     fontSize: '16px',
//                                     backgroundColor: localSelectedOption === idx
//                                         ? (question.options[idx] === question.correctAnswer
//                                             ? (darkMode ? '#2d6a4f' : '#28a745')
//                                             : (darkMode ? '#b02a37' : '#dc3545'))
//                                         : (darkMode ? '#c084fc' : '#7c3aed'),
//                                 }}>
//                                     {String.fromCharCode(65 + idx)}
//                                 </span>
//                                 <span style={{
//                                     fontSize: window.innerWidth <= 768 ? '15px' : '16px',
//                                     lineHeight: '1.5',
//                                     flex: 1,
//                                 }}>{option}</span>
//                             </div>
//                         ))}
//                     </div>

//                     {/* Result Message */}
//                     {/* {localSelectedOption !== null && (
//                         <div style={{
//                             padding: '16px',
//                             borderRadius: '12px',
//                             marginBottom: '20px',
//                             backgroundColor: question.options[localSelectedOption] === question.correctAnswer
//                                 ? (darkMode ? '#1e4a2a' : '#d4edda')
//                                 : (darkMode ? '#5a2a2a' : '#f8d7da'),
//                             color: question.options[localSelectedOption] === question.correctAnswer
//                                 ? (darkMode ? '#ffffff' : '#155724')
//                                 : (darkMode ? '#ffffff' : '#721c24'),
//                             textAlign: 'center',
//                             fontWeight: '600',
//                         }}>
//                             {question.options[localSelectedOption] === question.correctAnswer
//                                 ? language === 'hi' ? '✅ सही उत्तर!' : '✅ Correct Answer!'
//                                 : language === 'hi' ? '❌ गलत उत्तर। सही उत्तर है: ' + question.correctAnswer
//                                     : '❌ Wrong answer. Correct answer is: ' + question.correctAnswer}
//                         </div>
//                     )} */}

//                     {/* Explanation Section */}
//                     {question.explanation && (
//                         <div style={{
//                             padding: '24px',
//                             borderRadius: '16px',
//                             border: '1px solid',
//                             marginTop: '8px',
//                             backgroundColor: darkMode ? '#1e293b' : '#f8fafc',
//                             borderColor: darkMode ? '#334155' : '#e2e8f0',
//                             borderLeft: `4px solid ${darkMode ? '#c084fc' : '#7c3aed'}`,
//                         }}>
//                             <h4 style={{
//                                 fontSize: '18px',
//                                 fontWeight: '600',
//                                 marginBottom: '16px',
//                                 color: darkMode ? '#c084fc' : '#7c3aed',
//                             }}>
//                                 {getExplanationTitle()}
//                             </h4>
//                             <div style={{
//                                 fontSize: window.innerWidth <= 768 ? '15px' : '16px',
//                                 lineHeight: '1.8',
//                                 color: darkMode ? '#e2e8f0' : '#334155',
//                                 whiteSpace: 'pre-line'
//                             }}>
//                                 {formatExplanation(
//                                     question.explanation,
//                                 )}
//                             </div>
//                             <h4 style={{
//                                 fontSize: '18px',
//                                 fontWeight: '600',
//                                 marginBottom: '16px',
//                                 color: darkMode ? '#c084fc' : '#7c3aed',
//                             }}>
//                                 {getExplanationTitle()}
//                             </h4>
//                             <div style={{
//                                 fontSize: window.innerWidth <= 768 ? '15px' : '16px',
//                                 lineHeight: '1.8',
//                                 color: darkMode ? '#e2e8f0' : '#334155',
//                                 whiteSpace: 'pre-line'
//                             }}>
//                                 {formatExplanation(
//                                     question.explanationHi
//                                 )}
//                             </div>
//                         </div>
//                     )}
//                 </div>

//                 {/* Footer */}
//                 <div style={{
//                     padding: '16px',
//                     textAlign: 'center',
//                     fontSize: '13px',
//                     borderTop: '1px solid',
//                     backgroundColor: darkMode ? '#1e293b' : '#f8fafc',
//                     borderTopColor: darkMode ? '#334155' : '#e2e8f0',
//                     color: darkMode ? '#64748b' : '#94a3b8',
//                 }}>
//                     Press ESC or click ✕ to exit focus mode
//                 </div>
//             </div>
//         </div>
//     );
// };

// const styles = {
//     container: {
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         width: '100vw',
//         height: '100vh',
//         zIndex: 9999,
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//     },
//     overlay: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backdropFilter: 'blur(10px)',
//         cursor: 'pointer',
//     },
//     contentWrapper: {
//         position: 'relative',
//         width: '90%',
//         maxHeight: '90vh',
//         borderRadius: '24px',
//         boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
//         overflow: 'hidden',
//         display: 'flex',
//         flexDirection: 'column',
//         zIndex: 10000,
//         animation: 'slideUp 0.3s ease',
//     },
//     header: {
//         padding: '20px 24px',
//         borderBottom: '2px solid',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '12px',
//     },
//     headerIcon: {
//         fontSize: '24px',
//     },
//     headerTitle: {
//         flex: 1,
//         fontSize: '20px',
//         fontWeight: '600',
//     },
//     closeButton: {
//         width: '36px',
//         height: '36px',
//         borderRadius: '50%',
//         border: 'none',
//         fontSize: '18px',
//         fontWeight: 'bold',
//         cursor: 'pointer',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         transition: 'all 0.2s ease',
//         boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
//     },
//     content: {
//         padding: '28px',
//         overflowY: 'auto',
//         flex: 1,
//     },
//     questionContainer: {
//         padding: '24px',
//         borderRadius: '16px',
//         border: '1px solid',
//         marginBottom: '24px',
//     },
// };

// export { FocusModePopup, FocusModeButton };

import React, { useContext, useEffect, useState } from 'react';
import { themeContext } from '../Context';

const FocusModeButton = ({ onClick, darkMode, size }) => {
    const isMobile = window.innerWidth <= 768;

    return (
        <button
            onClick={onClick}
            className="action-button"
            style={{
                padding: isMobile ? '8px 12px' : '10px 16px',
                borderRadius: '8px',
                border: 'none',
                backgroundColor: '#9c27b0',
                color: 'white',
                fontSize: isMobile ? '12px' : '14px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                transition: 'all 0.2s ease',
                boxShadow: '0 4px 12px rgba(156, 39, 176, 0.3)',
            }}
            onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#7b1fa2';
                e.target.style.transform = 'scale(1.02)';
            }}
            onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#9c27b0';
                e.target.style.transform = 'scale(1)';
            }}
        >
            <span style={{ fontSize: '16px' }}>🔍</span>
            Focus Mode
        </button>
    );
};

const FocusModePopup = ({
    isOpen,
    onClose,
    question,
    language,
    questionNumber,
    totalQuestions,
    onNextQuestion,
    onPrevQuestion,
    onOptionSelect,
    selectedOption,
    showCorrectAnswer = true,
    selectedTag
}) => {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
    const [localSelectedOption, setLocalSelectedOption] = useState(null);
    const [showExplanation, setShowExplanation] = useState(false);
    const [isNavigating, setIsNavigating] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    // Add animations
    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            @keyframes slideUp {
                from {
                    opacity: 0;
                    transform: translateY(20px);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }
            
            @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
            }
            
            .focus-mode-enter {
                animation: fadeIn 0.3s ease;
            }
            
            .focus-mode-slide {
                animation: slideUp 0.3s ease;
            }
        `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    // Handle resize
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Reset selected option when question changes
    useEffect(() => {
        setLocalSelectedOption(null);
        setShowExplanation(false);
        setIsNavigating(false);
    }, [question]);

    // Handle escape key
    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape' && isOpen) {
                onClose();
            }
        };

        if (isOpen) {
            document.body.style.overflow = "hidden";
            window.addEventListener('keydown', handleEscKey);
        }

        return () => {
            document.body.style.overflow = "auto";
            window.removeEventListener('keydown', handleEscKey);
        };
    }, [isOpen, onClose]);

    if (!isOpen || !question) return null;

    // Get localized question directly in the popup
    const getLocalizedQuestion = () => {
        if (!question) return { question: '', options: [] };

        if (language === 'en') {
            return {
                question: question.question,
                options: question.options
            };
        }

        if (language === 'hi' && question.questionHi) {
            return {
                question: question.questionHi,
                options: question.optionsHi || question.options
            };
        }

        if (language === 'bilingual' && question.questionHi) {
            return {
                question: `${question.question}\n\n${question.questionHi}`,
                options: question.options.map((enOpt, idx) => {
                    const hiOpt = question.optionsHi?.[idx];
                    return hiOpt ? `${enOpt} / ${hiOpt}` : enOpt;
                })
            };
        }

        return {
            question: question.question,
            options: question.options
        };
    };

    const getOptionStyle = (option, index) => {
        const isSelected = localSelectedOption === index;
        const isCorrect = question.options[index] === question.correctAnswer;

        const baseStyle = {
            padding: isMobile ? '12px 16px' : '16px 20px',
            borderRadius: '12px',
            border: '1px solid',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            cursor: localSelectedOption === null ? 'pointer' : 'default',
            transition: 'all 0.2s ease',
            marginBottom: "10px",
            width: '100%',
            boxSizing: 'border-box'
        };

        // If no option selected yet
        if (localSelectedOption === null) {
            return {
                ...baseStyle,
                backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                borderColor: darkMode ? '#334155' : '#e2e8f0',
                color: darkMode ? '#f1f5f9' : '#0f172a',
            };
        }

        // AFTER SELECTION - Show correct answer highlighted
        if (isCorrect) {
            return {
                ...baseStyle,
                backgroundColor: darkMode ? '#1e4a2a' : '#d4edda',
                borderColor: darkMode ? '#2d6a4f' : '#28a745',
                color: darkMode ? '#ffffff' : '#155724',
                fontWeight: isSelected ? '700' : '500',
                opacity: 1,
            };
        }

        // Dimmed style for incorrect, unselected options after selection
        return {
            ...baseStyle,
            backgroundColor: darkMode ? '#1e293b' : '#f8fafc',
            borderColor: darkMode ? '#334155' : '#e2e8f0',
            color: darkMode ? '#94a3b8' : '#64748b',
            opacity: '0.6',
        };
    };

    const handleOptionClick = (index) => {
        if (localSelectedOption === null) {
            setLocalSelectedOption(index);
            if (onOptionSelect) {
                const localizedQuestion = getLocalizedQuestion();
                const selectedOptionText = localizedQuestion.options[index];
                // Pass both the index and the actual option text
                onOptionSelect(question.id, index, selectedOptionText);
            }
        }
    };

    const handleNextClick = () => {
        if (isNavigating) return;
        setIsNavigating(true);
        if (onNextQuestion) {
            onNextQuestion();
        }
        setTimeout(() => setIsNavigating(false), 300);
    };

    const handlePrevClick = () => {
        if (isNavigating) return;
        setIsNavigating(true);
        if (onPrevQuestion) {
            onPrevQuestion();
        }
        setTimeout(() => setIsNavigating(false), 300);
    };

    const localizedQuestion = getLocalizedQuestion();

    const formatExplanation = (text, hindiText) => {
        if (!text) return null;

        if (language === 'bilingual' && hindiText) {
            const lines = text.split('\n');
            const hindiLines = hindiText.split('\n');
            const mergedLines = [];

            const maxLines = Math.max(lines.length, hindiLines.length);

            for (let i = 0; i < maxLines; i++) {
                const engLine = lines[i] || '';
                const hinLine = hindiLines[i] || '';

                if (engLine.trim() === '' && hinLine.trim() === '') {
                    mergedLines.push('');
                    continue;
                }

                mergedLines.push(`${engLine} / ${hinLine}`);
            }
            return mergedLines.join('\n');
        }

        if (language === 'hi' && hindiText) {
            return hindiText;
        }

        return text;
    };

    const getExplanationTitle = () => {
        switch (language) {
            case 'hi': return 'व्याख्या';
            case 'bilingual': return 'Explanation / व्याख्या';
            default: return 'Explanation';
        }
    };

    return (
        <div style={styles.container} className="focus-mode-enter">
            {/* Background Overlay */}
            <div
                style={{
                    ...styles.overlay,
                    backgroundColor: darkMode ? 'rgba(0, 0, 0, 0.9)' : 'rgba(0, 0, 0, 0.7)',
                }}
                onClick={onClose}
            />

            {/* Focused Content */}
            <div style={{
                ...styles.contentWrapper,
                backgroundColor: darkMode ? '#0f172a' : '#ffffff',
                maxWidth: isMobile ? '95%' : '70%',
                maxHeight: isMobile ? '95vh' : '90vh',
            }} className="focus-mode-slide">
                {/* Header with Site Name and Question Counter */}
                <div style={{
                    ...styles.header,
                    backgroundColor: darkMode ? '#2e1a47' : '#f5f0ff',
                    borderBottomColor: darkMode ? '#c084fc' : '#7c3aed',
                    justifyContent: 'space-between',
                    padding: isMobile ? '12px 16px' : '16px 20px',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '8px' : '12px', flexWrap: 'wrap' }}>
                        <span style={styles.headerIcon}>📌</span>
                        <span style={{
                            fontSize: isMobile ? '12px' : '14px',
                            fontWeight: '500',
                            color: darkMode ? '#c084fc' : '#7c3aed',
                            background: darkMode ? 'rgba(192, 132, 252, 0.1)' : 'rgba(124, 58, 237, 0.1)',
                            padding: isMobile ? '4px 8px' : '4px 10px',
                            borderRadius: '20px',
                        }}>
                            SSCVIDYA
                        </span>

                        {/* Selected Tag Display */}
                        {selectedTag && selectedTag !== "All" && (
                            <span style={{
                                fontSize: isMobile ? '11px' : '14px',
                                fontWeight: '600',
                                color: darkMode ? '#fbbf24' : '#b45309',
                                background: darkMode ? 'rgba(251, 191, 36, 0.1)' : 'rgba(180, 83, 9, 0.1)',
                                padding: isMobile ? '4px 8px' : '4px 12px',
                                borderRadius: '20px',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                            }}>
                                {selectedTag}
                            </span>
                        )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '8px' : '16px' }}>
                        <span style={{
                            ...styles.headerTitle,
                            color: darkMode ? '#f1f5f9' : '#0f172a',
                            fontSize: isMobile ? '14px' : '16px',
                        }}>
                            Q{questionNumber}{totalQuestions ? `/${totalQuestions}` : ''}
                        </span>
                        <button
                            onClick={onClose}
                            style={{
                                ...styles.closeButton,
                                backgroundColor: darkMode ? '#1e293b' : '#ffffff',
                                color: darkMode ? '#c084fc' : '#7c3aed',
                                width: isMobile ? '28px' : '32px',
                                height: isMobile ? '28px' : '32px',
                                fontSize: isMobile ? '14px' : '16px',
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = darkMode ? '#334155' : '#f5f0ff';
                                e.target.style.transform = 'scale(1.05)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = darkMode ? '#1e293b' : '#ffffff';
                                e.target.style.transform = 'scale(1)';
                            }}
                        >
                            ✕
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div style={{
                    ...styles.content,
                    padding: isMobile ? '16px' : '24px',
                }}>
                    {/* Question Text */}
                    <div style={{
                        ...styles.questionContainer,
                        backgroundColor: darkMode ? '#1e293b' : '#f8fafc',
                        borderColor: darkMode ? '#334155' : '#e2e8f0',
                        padding: isMobile ? '16px' : '20px',
                        marginBottom: '20px',
                    }}>
                        <h3 style={{
                            fontSize: isMobile ? '16px' : '18px',
                            fontWeight: '600',
                            color: darkMode ? '#f1f5f9' : '#0f172a',
                            margin: 0,
                            lineHeight: '1.6',
                            whiteSpace: 'pre-line',
                        }}>
                            {localizedQuestion.question}
                        </h3>
                        {question.exam && (
                            <p style={{
                                fontSize: isMobile ? '12px' : '13px',
                                color: 'orange',
                                marginTop: '12px',
                                fontStyle: 'italic',
                                fontWeight: "bold"
                            }}>
                                {question.exam}
                            </p>
                        )}
                    </div>

                    {/* Options */}
                    <div>
                        {localizedQuestion.options.map((option, idx) => (
                            <div
                                key={idx}
                                onClick={() => handleOptionClick(idx)}
                                style={getOptionStyle(option, idx)}
                            // onMouseEnter={(e) => {
                            //     if (localSelectedOption === null) {
                            //         e.currentTarget.style.transform = 'translateY(-2px)';
                            //         e.currentTarget.style.boxShadow = darkMode
                            //             ? '0 4px 12px rgba(192, 132, 252, 0.2)'
                            //             : '0 4px 12px rgba(124, 58, 237, 0.2)';
                            //     }
                            // }}
                            // onMouseLeave={(e) => {
                            //     if (localSelectedOption === null) {
                            //         e.currentTarget.style.transform = 'translateY(0)';
                            //         e.currentTarget.style.boxShadow = 'none';
                            //     }
                            // }}
                            >
                                <span style={{
                                    width: isMobile ? '28px' : '32px',
                                    height: isMobile ? '28px' : '32px',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    fontSize: isMobile ? '14px' : '16px',
                                    backgroundColor: localSelectedOption !== null && question.options[idx] === question.correctAnswer
                                        ? (darkMode ? '#2d6a4f' : '#28a745')
                                        : (darkMode ? '#c084fc' : '#7c3aed'),
                                    flexShrink: 0,
                                }}>
                                    {String.fromCharCode(65 + idx)}
                                </span>
                                <span style={{
                                    fontSize: isMobile ? '14px' : '16px',
                                    lineHeight: '1.5',
                                    flex: 1,
                                    wordBreak: 'break-word',
                                }}>{option}</span>
                            </div>
                        ))}
                    </div>

                    {/* Navigation and Explanation Toggle */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '20px',
                        marginBottom: '10px',
                        flexWrap: isMobile ? 'wrap' : 'nowrap',
                        gap: isMobile ? '10px' : '0',
                    }}>
                        <button
                            onClick={handlePrevClick}
                            disabled={questionNumber <= 1 || isNavigating}
                            style={{
                                padding: isMobile ? '6px 12px' : '8px 16px',
                                borderRadius: '20px',
                                border: '1px solid',
                                borderColor: darkMode ? '#334155' : '#e2e8f0',
                                backgroundColor: 'transparent',
                                color: darkMode ? '#94a3b8' : '#64748b',
                                fontSize: isMobile ? '13px' : '14px',
                                cursor: (questionNumber <= 1 || isNavigating) ? 'not-allowed' : 'pointer',
                                opacity: (questionNumber <= 1 || isNavigating) ? 0.3 : 1,
                                transition: 'all 0.2s ease',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                            }}
                            onMouseEnter={(e) => {
                                if (questionNumber > 1 && !isNavigating) {
                                    e.target.style.backgroundColor = darkMode ? '#334155' : '#f1f5f9';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (questionNumber > 1 && !isNavigating) {
                                    e.target.style.backgroundColor = 'transparent';
                                }
                            }}
                        >
                            ← Prev
                        </button>

                        {/* Explanation Toggle */}
                        {question.explanation && (
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                            }}>
                                <span style={{
                                    fontSize: isMobile ? '11px' : '12px',
                                    color: darkMode ? '#94a3b8' : '#64748b',
                                }}>
                                    Explain
                                </span>
                                <div
                                    onClick={() => setShowExplanation(!showExplanation)}
                                    style={{
                                        width: isMobile ? '32px' : '36px',
                                        height: isMobile ? '16px' : '18px',
                                        backgroundColor: showExplanation
                                            ? (darkMode ? '#c084fc' : '#7c3aed')
                                            : (darkMode ? '#475569' : '#cbd5e1'),
                                        borderRadius: '20px',
                                        position: 'relative',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        opacity: 0.7,
                                    }}
                                >
                                    <div style={{
                                        width: isMobile ? '12px' : '14px',
                                        height: isMobile ? '12px' : '14px',
                                        backgroundColor: 'white',
                                        borderRadius: '50%',
                                        position: 'absolute',
                                        top: '2px',
                                        left: showExplanation ? (isMobile ? '18px' : '20px') : '2px',
                                        transition: 'left 0.2s ease',
                                        boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                    }} />
                                </div>
                            </div>
                        )}

                        <button
                            onClick={handleNextClick}
                            disabled={questionNumber >= totalQuestions || isNavigating}
                            style={{
                                padding: isMobile ? '6px 12px' : '8px 16px',
                                borderRadius: '20px',
                                border: '1px solid',
                                borderColor: darkMode ? '#334155' : '#e2e8f0',
                                backgroundColor: 'transparent',
                                color: darkMode ? '#94a3b8' : '#64748b',
                                fontSize: isMobile ? '13px' : '14px',
                                cursor: (questionNumber >= totalQuestions || isNavigating) ? 'not-allowed' : 'pointer',
                                opacity: (questionNumber >= totalQuestions || isNavigating) ? 0.3 : 1,
                                transition: 'all 0.2s ease',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                            }}
                            onMouseEnter={(e) => {
                                if (questionNumber < totalQuestions && !isNavigating) {
                                    e.target.style.backgroundColor = darkMode ? '#334155' : '#f1f5f9';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (questionNumber < totalQuestions && !isNavigating) {
                                    e.target.style.backgroundColor = 'transparent';
                                }
                            }}
                        >
                            Next →
                        </button>
                    </div>

                    {/* Explanation Section - Conditionally Rendered */}
                    {question.explanation && showExplanation && (
                        <div style={{
                            padding: isMobile ? '16px' : '20px',
                            borderRadius: '12px',
                            border: '1px solid',
                            marginTop: '16px',
                            backgroundColor: darkMode ? '#1e293b' : '#f8fafc',
                            borderColor: darkMode ? '#334155' : '#e2e8f0',
                            borderLeft: `3px solid ${darkMode ? '#c084fc' : '#7c3aed'}`,
                        }}>
                            <h4 style={{
                                fontSize: isMobile ? '14px' : '15px',
                                fontWeight: '500',
                                marginBottom: '12px',
                                color: darkMode ? '#c084fc' : '#7c3aed',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                            }}>
                                <span>📝</span>
                                {getExplanationTitle()}
                            </h4>
                            <div style={{
                                fontSize: isMobile ? '14px' : '15px',
                                lineHeight: '1.7',
                                color: darkMode ? '#e2e8f0' : '#334155',
                                whiteSpace: 'pre-line'
                            }}>
                                {formatExplanation(
                                    question.explanation,
                                    // question.explanationHi
                                )}
                            </div>
                            <h4 style={{
                                fontSize: isMobile ? '14px' : '15px',
                                fontWeight: '500',
                                marginBottom: '12px',
                                color: darkMode ? '#c084fc' : '#7c3aed',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                            }}>
                                <span>📝</span>
                                {getExplanationTitle()}
                            </h4>
                            <div style={{
                                fontSize: isMobile ? '14px' : '15px',
                                lineHeight: '1.7',
                                color: darkMode ? '#e2e8f0' : '#334155',
                                whiteSpace: 'pre-line'
                            }}>
                                {formatExplanation(
                                    // question.explanation,
                                    question.explanationHi
                                )}
                            </div>
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div style={{
                    padding: isMobile ? '8px' : '12px',
                    textAlign: 'center',
                    fontSize: isMobile ? '10px' : '11px',
                    borderTop: '1px solid',
                    backgroundColor: darkMode ? '#1e293b' : '#f8fafc',
                    borderTopColor: darkMode ? '#334155' : '#e2e8f0',
                    color: darkMode ? '#64748b' : '#94a3b8',
                }}>
                    ESC to exit • SSCVIDYA Focus Mode
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backdropFilter: 'blur(10px)',
        cursor: 'pointer',
    },
    contentWrapper: {
        position: 'relative',
        width: '90%',
        maxHeight: '90vh',
        borderRadius: '24px',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 10000,
    },
    header: {
        borderBottom: '2px solid',
        display: 'flex',
        alignItems: 'center',
    },
    headerIcon: {
        fontSize: '20px',
    },
    headerTitle: {
        fontWeight: '500',
    },
    closeButton: {
        borderRadius: '50%',
        border: 'none',
        fontWeight: 'bold',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    },
    content: {
        overflowY: 'auto',
        flex: 1,
    },
    questionContainer: {
        borderRadius: '16px',
        border: '1px solid',
    },
};

export { FocusModePopup, FocusModeButton };